import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="effective-attendance-rules--form"
export default class extends Controller {
  static targets = [
    "form",
    "attendanceRuleName",
    "attendanceRuleTimeSpan",
    "attendanceRuleDayMinutes",
    "attendanceRuleWeekMinutes",
    "attendanceRuleComment",
  ];

  connect() {
  }

  loadAttendanceRuleDetail(event) {
    const select = event.currentTarget;
    const attendanceRuleId = select.value;
    this.fetchAttendanceRuleDetail(attendanceRuleId);
  }

  fetchAttendanceRuleDetail(attendanceRuleId) {
    if (!attendanceRuleId) {
      this.showAttendanceRuleDetail();
      return;
    }

    fetch(`/attendance_rules/${attendanceRuleId}`)
      .then(response => {
        if (!response.ok) {
          throw new Error("Something went wrong.")
        }
        return response.json();
      })
      .then(data => {
        this.showAttendanceRuleDetail(data);
      })
      .catch(error => {
        console.error(error);
      })
  }

  showAttendanceRuleDetail(details = {}) {
    this.attendanceRuleNameTarget.value        = this.valueOrEmpty(details.name)
    this.attendanceRuleTimeSpanTarget.value    = this.valueOrEmpty(details.work_time_period)
    this.attendanceRuleDayMinutesTarget.value  = this.valueOrEmpty(details.daily_work_time)
    this.attendanceRuleWeekMinutesTarget.value = this.valueOrEmpty(details.weekly_work_time)
    this.attendanceRuleCommentTarget.value     = this.valueOrEmpty(details.comment)
  }

  valueOrEmpty(value) {
    return value ?? ""
  }
}
